import { render } from "./StoresView.vue?vue&type=template&id=3da4cb1e&scoped=true"
import script from "./StoresView.vue?vue&type=script&lang=js"
export * from "./StoresView.vue?vue&type=script&lang=js"

import "./StoresView.vue?vue&type=style&index=0&id=3da4cb1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da4cb1e"]])

export default __exports__